module.exports = "mutation CreateSparseUser($inviteId: ID) {\n  createSparseUser(inviteId: $inviteId) {\n    account {\n      token\n    }\n  }\n}\n"